import ISerializable from '../../../../lib/ISerializable';

export default class TemplateGeneratedData implements ISerializable {
  private templateAreas: {
    languageCode: string;
    name: string;
    text: string;
  }[] = [];

  private templateImages: {
    name: string;
    image: {
      ObjectURL: string;
      PresignedUrl: string;
    } | null;
  }[] = [];

  private templateStyleId: number;

  private websiteTemplate: string;

  constructor(data?: {
    templateAreas: {
      languageCode: string;
      name: string;
      text: string;
    }[];
    templateImages: {
      name: string;
      image: {
        ObjectURL: string;
        PresignedUrl: string;
      } | null;
    }[];
    templateStyleId: number;
    websiteTemplate: string;
  }) {
    if (data) {
      this.templateAreas = data.templateAreas;
      this.templateImages = data.templateImages;
      this.templateStyleId = data.templateStyleId;
      this.websiteTemplate = data.websiteTemplate;
    }
  }

  public serialize(): string {
    let data = {
      templateAreas: this.templateAreas,
      templateImages: this.templateImages,
      templateStyleId: this.templateStyleId,
      websiteTemplate: this.websiteTemplate
    };

    return JSON.stringify(data);
  }
  public deserialize(data: string): void {
    let parsedData = JSON.parse(data);

    this.templateAreas = parsedData.templateAreas;
    this.templateImages = parsedData.templateImages;
    this.templateStyleId = parsedData.templateStyleId;
    this.websiteTemplate = parsedData.websiteTemplate;
  }

  public getTemplateAreas() {
    return this.templateAreas;
  }

  public getTemplateImages() {
    return this.templateImages;
  }

  public getTemplateStyleId() {
    return this.templateStyleId;
  }

  public getWebsiteTemplate() {
    return this.websiteTemplate;
  }

  public getDataToBeInjectedInThePreview() {
    return {
      templateAreas: this.getTemplateAreas(),
      templateImages: this.getTemplateImages()
    };
  }
}
